import React from 'react'
import logo from './logo.svg'
import './App.css'
import RoutesNotifica from './config/routes'

const App: React.FC = () => (
    <>
            <RoutesNotifica />
    </>
);

export default App;
